import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import insert from './insert.js'
import display from './display.js'
import init from "./init.js"

export default contract({
  display: array([
    display
  ]),
  init: array([
    init
  ]),
  insert: array([
    insert
  ])
})